"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDict = exports.loadDictData = exports.dict = void 0;
const complex_data_1 = require("complex-data");
const select_1 = __importDefault(require("../api/select"));
const load_1 = __importDefault(require("./load"));
const configKeys = [
    'business_lines_green',
    'ASSIGN_TYPE',
    'DAY_NUM',
    'GuaranteeType',
    'CASE_COLLECTION_TYPE',
    'BONDSMAN_STATUS',
    'WAY_OF_SIGNING',
    'family_relative_guarantee',
    'SEND_TYPE',
    'CollectionRecordRiskType',
    'familyrelative',
    'CollectionRecordOverReason',
    'CollectionRecordCollectionResult',
    'relation_type',
    'CertType',
    'sex',
    'marry',
    'leas_form',
    'business_lines',
    'business_types',
    'area',
    'FLOW_END_REASON',
    'LITIGATION_TYPE',
    'LITIGATION_REQUEST_TYPE',
    'litigationJudgmentResultType',
    'litigationJudgmentExecutionPlanType',
    'closeCaseReasonType',
    'litigationCollectionContentType',
    'litigationCollectionMethodType',
    'LitigationExecuteUnsealReason',
    'LitigationExecuteUnsealContent',
    'LitigationSeizeUnsealReason',
    'LitigationSeizeUnsealContent',
    'vehicleDisposalType',
];
exports.dict = {};
const loadDictData = function () {
    return new Promise((resolve, reject) => {
        select_1.default.dict.require(configKeys).then((res) => {
            const dictData = {};
            for (const key in res.data.data) {
                dictData[key] = res.data.data[key].map(item => {
                    return {
                        value: item.key,
                        label: item.value
                    };
                });
            }
            resolve({ status: 'success', data: dictData });
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            reject(err);
        });
    });
};
exports.loadDictData = loadDictData;
const loadDict = function () {
    return load_1.default.pushControl('dict', {
        offset: 80 * 1000,
        priority: 1,
        local: 'dict',
        check(localData) {
            if (localData) {
                const localKeys = Object.keys(localData);
                if (localKeys.length === configKeys.length) {
                    for (let i = 0; i < configKeys.length; i++) {
                        const key = configKeys[i];
                        if (localKeys.indexOf(key) === -1) {
                            return;
                        }
                    }
                    return true;
                }
            }
        },
        load() {
            return (0, exports.loadDictData)();
        },
        init(initData) {
            for (const key in initData) {
                exports.dict[key] = new complex_data_1.SelectList({
                    name: key,
                    prop: key,
                    list: initData[key]
                });
            }
        }
    });
};
exports.loadDict = loadDict;
